module.exports = __webpack_public_path__ + "img/Welding_Ring_Set.874daa28.png";